/**
 * The pages that exist only to explain why the portal is closed to someone:
 * no organization, no role, or account disabled.
 */

export const BLOCKED_PAGES = [
  'no-organization',
  'no-role',
  'account-disabled',
] as const

export type BlockedPage = (typeof BLOCKED_PAGES)[number]

/** What the rule is decided on, as the auth store and the poll report it. */
export type AccessState = {
  hasNoOrganization: boolean
  hasNoValidRole: boolean
  isAccountDisabled: boolean
  isLoggedIn: boolean
}

export const isBlockedPage = (
  name: unknown,
): name is BlockedPage =>
  typeof name === 'string' && (BLOCKED_PAGES as readonly string[]).includes(name)

/** Whether `name` is a page this caller should be able to reach. */
export const canSeeBlockedPage = (
  name: BlockedPage,
  state: AccessState,
): boolean => {
  switch (name) {
    case 'no-organization':
      return state.hasNoOrganization
    case 'no-role':
      return state.hasNoValidRole
    case 'account-disabled':
      return state.isAccountDisabled || !state.isLoggedIn
  }
}
